export const skillList = [
    {
        skillName: 'HTML',
        skillUrl: 'https://user-images.githubusercontent.com/31516195/170096301-84bb07bb-c807-46e4-a7d1-72e3f86c611c.png',
    },
    {
        skillName: 'CSS',
        skillUrl: 'https://user-images.githubusercontent.com/31516195/170096288-b6a601b7-7f5c-489e-be56-f9a7d61208f4.png',
    },
    {
        skillName: 'JavaScript',
        skillUrl: 'https://user-images.githubusercontent.com/31516195/170096309-ad1895af-57fc-4744-ad4c-35888c4f125b.png',
    },
    {
        skillName: 'React',
        skillUrl: 'https://user-images.githubusercontent.com/31516195/170096335-c6a18931-394d-444f-918a-51e1d052347b.png',
    },
    {
        skillName: 'NodeJS',
        skillUrl: 'https://user-images.githubusercontent.com/31516195/170096325-d548fb46-5806-41a1-8af6-43a1bdcc7f89.png',
    },
    /*
    {
        skillName: 'TypeScript', not yet learned but will learn soon
        skillUrl: 'https://user-images.githubusercontent.com/31516195/170096347-7a6e9142-2aeb-4a1c-bcbb-da12a21d3aca.png',
    },
    {
        skillName: 'MongoDB', not yet learned but will learn soon
        skillUrl: 'https://user-images.githubusercontent.com/31516195/170096317-6eabc365-6fb1-41e2-b699-ea18f202a145.png',
    },
    */
    {
        skillName : 'Mysql',
        skillUrl: 'https://user-images.githubusercontent.com/31516195/170096321-7dc0e110-e99b-49c2-831b-aa72ede1a82e.png'
    },
    {
        skillName : 'Php',
        skillUrl: 'https://user-images.githubusercontent.com/31516195/170097980-463780a1-6a86-4d8a-8ba4-dcc882fdf57a.png'
    },
    /*
    {
        skillName : 'Vue.js', not yet learned but will learn soon
        skillUrl: 'https://user-images.githubusercontent.com/31516195/170096352-411826c2-3fcc-410a-bdfb-ce5119acf397.png'
    },
    */
];
